import { useTranslation } from 'react-i18next';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

export const useHelpDialogShortcuts = (handler: () => void): void => {
  const { t } = useTranslation();

  useKeyboardShortcuts([
    {
      category: 'common',
      description: t('keyboardShortcuts.openHelpDialog'),
      keys: '?',
      handler,
    },
  ]);
};
